$(function () {

  var arySpinnerCtrl = [];
  var spin_speed = 20; //変動スピード

  //長押し押下時
  $('.btnspinner').on('touchstart mousedown click', function (e) {

    if (arySpinnerCtrl['interval']) return false;
    var target = $(this).data('target');
    arySpinnerCtrl['target'] = target;
    arySpinnerCtrl['timestamp'] = e.timeStamp;
    arySpinnerCtrl['cal'] = Number($(this).data('cal'));
    //クリックは単一の処理に留める
    if (e.type == 'click') {
      spinnerCal();
      arySpinnerCtrl = [];
      return false;
    }
    //長押し時の処理
    setTimeout(function () {
      //インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
      if (!arySpinnerCtrl['interval'] && arySpinnerCtrl['timestamp'] == e.timeStamp) {
        arySpinnerCtrl['interval'] = setInterval(spinnerCal, spin_speed);
      }
    }, 500);
  });

  //長押し解除時 画面スクロールも解除に含む
  $(document).on('touchend mouseup scroll', function (e) {
    if (arySpinnerCtrl['interval']) {
      clearInterval(arySpinnerCtrl['interval']);
      arySpinnerCtrl = [];
    }
  });

  //変動計算関数
  function spinnerCal() {
    var target = $(arySpinnerCtrl['target']);
    var num = Number(target.val());
    num = num + arySpinnerCtrl['cal'];
    if (num > Number(target.data('max'))) {
      target.val(Number(target.data('max')));
    } else if (1 > num) {
      target.val(1);
    } else {
      target.val(num);
    }
  }

});

$(function () {
  $('.menu-btn').on('click', function () {
    $('.blur , .gnav , .btn , .btn-line').toggleClass('open');
  })
});

$(function () {
  var setImg = '.top-slide';
  var fadeSpeed = 2000;
  var switchDelay = 5000;
  var $slides = $(setImg).children();

  // 各スライドは直下の img または picture（Liquid のブロック）のどちらか
  if ($slides.length < 2) {
    return;
  }

  $slides.css({ opacity: '0' });
  $slides.first().stop().animate({ opacity: '1', zIndex: '-1' }, fadeSpeed);

  setInterval(function () {
    var $wrap = $(setImg);
    var $first = $wrap.children().first();
    var $next = $first.next();
    if (!$next.length) {
      return;
    }
    $first.animate({ opacity: '0', zIndex: '-2' }, fadeSpeed);
    $next.animate({ opacity: '1', zIndex: '-1' }, fadeSpeed);
    $first.appendTo($wrap);
  }, switchDelay);
});

$(window).on('load scroll', function () {
  var box = $('.fadein');
  var animated = 'animated';

  box.each(function () {

    var boxOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if (scrollPos > boxOffset - wh + 100) {
      $(this).addClass(animated);
    }
  });

});


$(function () {
  // 切り替える対象にclass属性。
  var $elem = $('.switch');
  // 切り替えの対象のsrc属性の末尾の文字列。
  var sp = '_sp.';
  var pc = '_pc.';
  // 画像を切り替えるウィンドウサイズ。
  var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt($(window).width());

    // ページ内にあるすべての`.switch`に適応される。
    $elem.each(function () {
      var $this = $(this);
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if (windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));

        // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      imageSwitch();
    }, 200);
  });
});